import React from "react";
import styled from "styled-components";
import { Flex, Text } from "../../../assets/ui";
import { ChampionIcon } from "../../../assets/icons";
import Theme from "../../../assets/ui/theme";

const StyledSectionWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  background: url("/images/sport-venue-bg.png");
  padding: 120px 16px 90px;
`;

const SportVenue = () => {
  return (
    <StyledSectionWrapper>
      <ChampionIcon />

      <Text
        fontSize={["14px"]}
        lineHeight={["17px"]}
        color={Theme.colors.subTitle}
        marginTop={["32px"]}
        marginBottom={["16px"]}
      >
        Sales role
      </Text>
      <Text
        fontSize={["36px", null, "48px"]}
        lineHeight={["42px", null, "59px"]}
        color={Theme.colors.white}
        textAlign="center"
        maxWidth="455px"
        fontWeight="bold"
        marginBottom={["32px", null, "70px"]}
      >
        Any Sports Venue, large or small.
      </Text>
      <Text
        fontSize={["16px", null, "18px"]}
        lineHeight={["24px", null, "24px"]}
        color={"#E2EEFF"}
        textAlign="center"
        maxWidth="590px"
        marginBottom={["56px", null, "60px"]}
      >
        With every next venue using our software, you’ll make as a member of our
        dynamic team. So your number-one target is reaching those venues that
        already take a lot of bookings. Smaller venues or less popular sports
        are also perfect partners to bring to Exsportia, they mean we get to
        keep our promise of freedom in choice and they’ll add to your commission
        too. CHANGE
      </Text>
    </StyledSectionWrapper>
  );
};

export default SportVenue;
